import { Id, project } from "@planzone/dto";
import { State, Selector } from "./types";

function get(getState: () => State, projectId: Id) {
  return getState().find((res) => res.id === projectId);
}

function queryState(getState: () => State, projectId: Id) {
  return <Result>(
    query: (res: State[number]) => Result,
    fallBack: Result,
  ): Result => {
    const state = get(getState, projectId);

    return state ? query(state) : fallBack;
  };
}

function createSelector(getState: () => State): Selector {
  return {
    isProjectRetrievalRequestFailure(id) {
      return queryState(getState, id)((res) => res.request.isFailure, false);
    },
    isProjectRetrievalRequestPending(id) {
      return queryState(getState, id)((res) => res.request.isPending, false);
    },
    isProjectRetrievalRequestSuccess(id) {
      return queryState(getState, id)((res) => res.request.isSuccessful, false);
    },
    getProject(id) {
      return queryState(getState, id)((res) => res.project, project);
    },
  };
}

export { createSelector };
